/* eslint-disable local-rules/queries-must-be-in-queries-folder */
export function getHighlightedQuery(query: string, partToHighlight: string): string {
  if (partToHighlight === '') return query

  const escapedPartToHighlight = partToHighlight.replaceAll(/[\\^$*+?.()|[\]{}]/g, String.raw`\$&`)

  const regex = new RegExp(escapedPartToHighlight, 'gi')

  return query.replaceAll(regex, '<mark>$&</mark>')
}
